import { createContext, useEffect, useState, useContext, useRef } from "react";
import DateContext from "./DateProvider";
import { getEmissionsPerVehicleAPI } from "../api/VehiclePerformance/EmissionsPerVehicleAPI";
import { getAverageEmissionsPerVehicleAPI } from "../api/VehiclePerformance/AverageEmissionsPerVehicleAPI";
import { getTotalIdleTime } from "../api/VehiclePerformance/TotalIdleTimeAPI";
import { getIdleTimeEmissionsAPI } from "../api/VehiclePerformance/IdleTimeEmissionsAPI";
import { getVehiclePerformanceDataAPI } from "../api/VehiclePerformance/VehiclePerformanceDataAPI";
import { idleTimeEmissionsDataConfig } from "../constants/VehicleConfig";
import { getRankedVehicleProfileGroup } from "../api/VehiclePerformance/RankedVehicleProfileGroupAPI";

// INITIAL DATA TO IMPORT
import {
  averageEmissionsperVehicleSVGConfig,
  totalIdleTimeSVGConfig,
} from "../constants/EmissionsConfig";
import {
  emissionsPerVehicleSortDataConfig,
  addEditSidebarVPColumnsOptions,
  vpDataFilterOptionMapping,
  vpProfileOptionMapping,
  vpAccordionConfig,
} from "../constants/VehicleConfig";

const VehiclePerformanceContext = createContext({});

// Provides access to token across whole application
export const VehiclePerformanceProvider = ({ children }) => {
  // State: Initialize State - Full Page
  const [vehiclePerformanceIsLoading, setVehiclePerformanceIsLoading] =
    useState(true);

  // State: Initialize State - Emissions Per Vehicle
  const [emissionsPerVehicleData, setEmissionsPerVehicleData] = useState({
    loaded: false,
    data: [],
  });

  // State: Initialize State - Emissions Per Vehicle Bar Chart Data
  const [emissionsBarChartData, setEmissionsBarChartData] = useState({
    loaded: false,
    data: [],
  });

  // State: Initialize State - Average Emissions Per Vehicle
  const [averageEmissionsPerVehicle, setAverageEmissionsPerVehicle] = useState({
    loaded: false,
    value: 0,
  });

  // State: Initialize State - Total Idle Time
  const [totalIdleTime, setTotalIdleTime] = useState({
    loaded: false,
    data: {},
  });
  const [idleTimeEmissionsData, setIdleTimeEmissionsData] = useState({
    loaded: false,
    data: [],
  });

  // VEHICLE PERFORMANCE DATA TAB --------------------------------------------------------------------------------
  // State: Initialize State - Vehicle Performance Data Table
  const [vehiclePerformanceDataTable, setVehiclePerformanceDataTable] =
    useState({
      loaded: false,
      data: [],
    });

  // State: Initialize State - Vehicle Performance Data Table (Filtering Purposes)
  const [vpDataSelectedColumns, setVpDataSelectedColumns] = useState({
    edit: addEditSidebarVPColumnsOptions?.slice(1, 10),
    actual: addEditSidebarVPColumnsOptions?.slice(1, 10),
  });

  // State: Initialize State - Vehicle Performance Data Table (Filtering Purposes)
  const [
    filteredVehiclePerformanceDataTable,
    setFilteredVehiclePerformanceDataTable,
  ] = useState({
    loaded: false,
    data: [],
  });

  // State: Initialize State - Vehicle Performance Filter Vehicle
  const [vehiclePerformanceFilterVehicle, setVehiclePerformanceFilterVehicle] =
    useState();

  // State: Initialize State - Vehicle Performance Filter Sidebar All Filters
  const [vehiclePerformanceFilterSidebar, setVehiclePerformanceFilterSidebar] =
    useState(vpDataFilterOptionMapping);

  // State: Initialize State - Filters is Loading
  const [filtersIsLoading, setFiltersIsLoading] = useState({
    data: true,
    profile: true,
  });

  const [vpDataAccordionExpand, setVpDataAccordionExpand] =
    useState(vpAccordionConfig);
  // State: Initialize State - Clear Button Filter State
  const [clearButtonFilter, setClearButtonFilter] = useState({
    data: false,
    profile: false,
  });

  // State: Initialize State - Set Filter String
  const [filterString, setFilterString] = useState("");
  const [partialSearchFilterString, setPartialSearchFilterString] =
    useState("");

  // State: Initialize State - Selected Sort Value
  const [selectedVehicleSortValue, setSelectedVehicleSortValue] = useState(
    emissionsPerVehicleSortDataConfig[2].value
  );

  // State: Initialize State - Emissions Per Vehicle Bar Chart Data
  const itemsPerPage = 30;
  const [sliceValue, setSliceValue] = useState([0, itemsPerPage]);

  // NEW PROFILE DATA
  // State: Initialize State - Vehicle PROFILE Filter Vehicle
  const [vehicleProfileFilterVehicle, setVehicleProfileFilterVehicle] =
    useState();

  // State: Initialize State - Vehicle Profile Filter Sidebar All Filters
  const [vehicleProfileFilterSidebar, setVehicleProfileFilterSidebar] =
    useState(vpProfileOptionMapping);

  // PROFILE DATA ------------------------------------------------------------------------------
  // State: Vehicle Profile Data
  const [vehicleProfileData, setVehicleProfileData] = useState({
    loaded: false,
    data: [],
    nextPage: false,
  });

  // State: Initialize State - Vehicle Profile Data Page
  const [vehicleProfileDataPage, setVehicleProfileDataPage] = useState(1);

  // State: Initialize State - Filters Vehicle Profile Data
  const [filtersVehicleProfileData, setFiltersVehicleProfileData] = useState({
    loaded: false,
    data: [],
  });

  // State: Initialize State - Set Filter String
  const [profileFilterString, setProfileFilterString] = useState("");

  // Set State: Selected Vehiclde Data for Profile
  const [selectedVehicleData, setSelectedVehicleData] = useState({
    loaded: false,
    data: [],
  });
  const [vpProfileAccordionExpand, setVpProfileAccordionExpand] =
    useState(vpAccordionConfig);
  // USE EFFECT TO INITIALIZE CONTEXT & STATE ------------------------------------------------
  // Const: Initialize Context - Application Dates
  const { applicationDates, selectedChartRadioItemType } =
    useContext(DateContext);

  // Const: Get Token & Make Sure Available For API Call
  const token = localStorage.getItem("greenToken");

  const generateSidebarFilterString = (filterData, vehicleFilter) => {
    const vehicleFilterString =
      vehicleFilter?.data?.length > 0
        ? `&vehicleId=${vehicleFilter?.data
            ?.map((item) => item?.value)
            .join(",")}`
        : "";

    const metricFilterString = Object.keys(filterData?.filters || {})
      .map((key) => {
        // const divide1000 = [
        //   "emissions_distance_ch4_total_kg",
        //   "emissions_by_dist_n2o_mt",
        //   "emissions_distance_ch4_biomass_kg",
        //   "emissions_distance_n2o_biomass_kg",
        // ];
        const columnFilter = filterData?.filters?.[key];

        // Check if the data is applied (i.e., differs from minMax)
        if (
          columnFilter?.data[0] === columnFilter?.minMax[0] &&
          columnFilter?.data[1] === columnFilter?.minMax[1]
        ) {
          return ""; // Skip this filter if no range is applied
        }
        const bump =
          columnFilter.data[1] === columnFilter.minMax[1]
            ? Math.round(0.1 / 1, 5)
            : 0;

        // Generate the filter string for this column
        return `&min_${key}=${columnFilter?.data[0]}&max_${key}=${
          columnFilter?.data?.[1] === columnFilter?.minMax?.[1]
            ? columnFilter?.data?.[1] + bump
            : columnFilter?.data?.[1]
        }`;
      })
      .filter(Boolean) // Remove any empty strings
      .join("");

    return `${vehicleFilterString}${metricFilterString}`;
  };

  // UE: Initialize Filter High & Low Values when ApplicationDate Changes, Preserve Previous State
  useEffect(() => {
    if (
      filteredVehiclePerformanceDataTable?.data?.length > 0 &&
      filteredVehiclePerformanceDataTable?.loaded
    ) {
      const initialFilterGeneration = Object.keys(
        vpDataFilterOptionMapping?.filters || {}
      ).reduce((acc, key) => {
        // Generate the filtered data for each key
        const filteredData = filteredVehiclePerformanceDataTable?.data
          ?.map((row) => row?.[key])
          ?.filter((item) => item !== "Not Calculated");

        // Calculate the min and max values for the data
        const min = Math.min(...filteredData);
        const max = Math.max(...filteredData);

        // Assign the structure to the corresponding key in the accumulator object
        acc[key] = {
          ...vpDataFilterOptionMapping?.filters?.[key],
          column: key,
          data: [min, max],
          minMax: [min, max],
        };

        return acc;
      }, {});

      setVehiclePerformanceFilterSidebar({
        loaded: true,
        filters: initialFilterGeneration,
      });
      const vehicles = filteredVehiclePerformanceDataTable?.data?.map((row) => {
        return { label: row?.vehicle_id, value: row?.vehicle_id };
      });
      setVehiclePerformanceFilterVehicle({
        column: "vehicle_id",
        options: vehicles,
        data: [],
      });
    } else {
      setVehiclePerformanceFilterVehicle({
        column: "vehicle_id",
        options: [],
        data: [],
      });
    }
    setFiltersIsLoading((prevState) => ({
      ...prevState,
      data: false,
    }));
  }, [filteredVehiclePerformanceDataTable, clearButtonFilter?.data]);

  // UE: Get Vehicle Profile Data For Application(Trigger API Call) When applicationDates Changes
  useEffect(() => {
    if (
      filtersVehicleProfileData?.data?.length > 0 &&
      filtersVehicleProfileData?.loaded
    ) {
      const initialFilterGeneration = Object.keys(
        vpProfileOptionMapping?.filters || {}
      ).reduce((acc, key) => {
        // Generate the filtered data for each key
        const filteredData = filtersVehicleProfileData?.data
          ?.map((row) => row?.[key])
          ?.filter((item) => item !== "Not Calculated");

        // Calculate the min and max values for the data
        const min = Math.min(...filteredData);
        const max = Math.max(...filteredData);

        // Assign the structure to the corresponding key in the accumulator object
        acc[key] = {
          ...vpProfileOptionMapping?.filters?.[key],
          column: key,
          data: [min, max],
          minMax: [min, max],
        };

        return acc;
      }, {});

      setVehicleProfileFilterSidebar({
        loaded: true,
        filters: {
          ...initialFilterGeneration,
          rating: {
            type: "rangeslider",
            label: "EPA Rating",
            data: [0, 100],
            minMax: [0, 100],
            stepValue: 1,
          },
        },
      });

      const vehicles = filtersVehicleProfileData?.data?.map((row) => {
        return { label: row?.vehicle_id, value: row?.vehicle_id };
      });

      setVehicleProfileFilterVehicle({
        column: "vehicle_id",
        options: vehicles,
        data: [],
      });
    } else {
      setVehicleProfileFilterVehicle({
        column: "vehicle_id",
        options: [],
        data: [],
      });
    }
    setFiltersIsLoading((prevState) => ({
      ...prevState,
      profile: false,
    }));
  }, [filtersVehicleProfileData, clearButtonFilter?.profile]);

  // UE: Get Vehicle Performance Data For Application(Trigger API Call) When applicationDates Changes
  useEffect(() => {
    const hasValues =
      Object.values(applicationDates).filter((date) => date !== "").length > 0;

    if (vehiclePerformanceIsLoading && hasValues && token) {
      const promises = [
        getEmissionsPerVehicleAPI(
          setEmissionsPerVehicleData,
          setEmissionsBarChartData,
          applicationDates?.emissionsPerVehicle
        ),
        getAverageEmissionsPerVehicleAPI(
          setAverageEmissionsPerVehicle,
          applicationDates?.avgEmissionsPerVehicle
        ),
        getTotalIdleTime(setTotalIdleTime, applicationDates?.totalIdleTime),
        getIdleTimeEmissionsAPI(
          setIdleTimeEmissionsData,
          selectedChartRadioItemType?.idle_emissions,
          applicationDates?.idleChartEmissions
        ),
        // Initial API Call for Vehicle Performance Data Table
        getVehiclePerformanceDataAPI(
          setVehiclePerformanceDataTable,
          setFilteredVehiclePerformanceDataTable,
          applicationDates?.vpData,
          "",
          setFiltersVehicleProfileData
        ),
        // Initial API Call for Vehicle Rank Data
        getRankedVehicleProfileGroup(
          setVehicleProfileData,
          applicationDates?.vpProfile,
          "",
          vehicleProfileDataPage
        ),
      ];
      Promise.all(promises).then(() => {
        // Set Loading Component to False
        setVehiclePerformanceIsLoading(false);
      });
    }
  }, [vehiclePerformanceIsLoading, applicationDates, token]);

  // Const: Get Previous Application Dates to See if Trigger API Call
  const prevApplicationDates = useRef(applicationDates);

  // Const: Get Previous Selected Chart Radio Item Type to See if Trigger API Call
  const prevSelectedChartRadioItemType = useRef(selectedChartRadioItemType);

  // UE: Get Vehicle Performance Data For Application(Trigger API Call) When applicationDates Changes
  useEffect(() => {
    const hasValues =
      Object.values(applicationDates).filter((date) => date !== "").length > 0;

    if (
      hasValues &&
      token &&
      !vehiclePerformanceIsLoading &&
      prevApplicationDates?.current
    ) {
      if (
        prevApplicationDates?.current?.emissionsPerVehicle !==
        applicationDates?.emissionsPerVehicle
      ) {
        setSelectedVehicleSortValue("default");
        setEmissionsPerVehicleData({
          loaded: false,
          data: [],
        });
        setSliceValue([0, itemsPerPage]);
        getEmissionsPerVehicleAPI(
          setEmissionsPerVehicleData,
          setEmissionsBarChartData,
          applicationDates?.emissionsPerVehicle
        );
      }
      if (
        prevApplicationDates?.current?.avgEmissionsPerVehicle !==
        applicationDates?.avgEmissionsPerVehicle
      ) {
        getAverageEmissionsPerVehicleAPI(
          setAverageEmissionsPerVehicle,
          applicationDates?.avgEmissionsPerVehicle
        );
      }
      if (
        prevApplicationDates?.current?.totalIdleTime !==
        applicationDates?.totalIdleTime
      ) {
        getTotalIdleTime(setTotalIdleTime, applicationDates?.totalIdleTime);
      }
      if (prevApplicationDates?.current?.vpData !== applicationDates?.vpData) {
        setFilteredVehiclePerformanceDataTable({
          loaded: false,
          data: [],
        });
        // API Call For Change in Application Dates for Vehicle Performance Data Table (Reset Filters)
        getVehiclePerformanceDataAPI(
          setVehiclePerformanceDataTable,
          setFilteredVehiclePerformanceDataTable,
          applicationDates?.vpData,
          ""
        );
        setClearButtonFilter({
          ...clearButtonFilter,
          data: !clearButtonFilter,
        });
        setFilterString("");
        setPartialSearchFilterString("");
      }
      if (
        prevApplicationDates?.current?.vpProfile !== applicationDates?.vpProfile
      ) {
        setFiltersVehicleProfileData({
          loaded: false,
          data: [],
        });
        getVehiclePerformanceDataAPI(
          () => {},
          () => {},
          applicationDates?.vpProfile,
          "",
          setFiltersVehicleProfileData
        );
        // API Call For Change in Application Dates for Vehicle Performance Data Table (Reset Filters)
        getRankedVehicleProfileGroup(
          setVehicleProfileData,
          applicationDates?.vpProfile,
          "",
          vehicleProfileDataPage
        );
        setClearButtonFilter({
          ...clearButtonFilter,
          profile: !clearButtonFilter,
        });
        setProfileFilterString("");
      } else if (
        prevSelectedChartRadioItemType?.current?.idle_emissions !==
          selectedChartRadioItemType?.idle_emissions ||
        prevApplicationDates?.current?.idleChartEmissions !==
          applicationDates.idleChartEmissions
      ) {
        getIdleTimeEmissionsAPI(
          setIdleTimeEmissionsData,
          selectedChartRadioItemType?.idle_emissions,
          applicationDates?.idleChartEmissions
        );
      }
    }
    prevApplicationDates.current = applicationDates;
    prevSelectedChartRadioItemType.current = selectedChartRadioItemType;
  }, [
    applicationDates,
    selectedChartRadioItemType?.idle_emissions,
    token,
    vehiclePerformanceIsLoading,
  ]);

  // UE: Handle API Call For Filtering Vehicle Performance Data Table
  useEffect(() => {
    if (filteredVehiclePerformanceDataTable?.loaded) {
      getVehiclePerformanceDataAPI(
        setVehiclePerformanceDataTable,
        () => {},
        applicationDates?.vpData,
        `${filterString}${partialSearchFilterString}`
      );
    }
  }, [filterString, partialSearchFilterString]);

  // UE: Handle API Call For Filtering Vehicle Rank Profile Data
  useEffect(() => {
    if (filtersVehicleProfileData?.loaded) {
      getRankedVehicleProfileGroup(
        setVehicleProfileData,
        applicationDates?.vpProfile,
        profileFilterString,
        vehicleProfileDataPage
      );
    }
  }, [profileFilterString]);

  // UE: Handle API Call For Vehicle Profile Data w/ Pagination
  useEffect(() => {
    if (filtersVehicleProfileData?.loaded) {
      getRankedVehicleProfileGroup(
        setVehicleProfileData,
        applicationDates?.vpProfile,
        profileFilterString,
        vehicleProfileDataPage
      );
    }
  }, [vehicleProfileDataPage]);

  const value = {
    vehiclePerformanceIsLoading,
    emissionsPerVehicleData,
    averageEmissionsPerVehicle,
    totalIdleTime,
    idleTimeEmissionsData,
    vehiclePerformanceDataTable,
    vehiclePerformanceFilterVehicle,
    setVehiclePerformanceFilterVehicle,
    filtersIsLoading,
    clearButtonFilter,
    setClearButtonFilter,
    selectedVehicleSortValue,
    setSelectedVehicleSortValue,
    emissionsBarChartData,
    setEmissionsBarChartData,
    sliceValue,
    setSliceValue,
    itemsPerPage,
    vehicleProfileData,
    setVehicleProfileData,
    vehicleProfileFilterVehicle,
    setVehicleProfileFilterVehicle,
    filterString,
    setFilterString,
    profileFilterString,
    setProfileFilterString,
    selectedVehicleData,
    setSelectedVehicleData,
    vehicleProfileDataPage,
    setVehicleProfileDataPage,
    vpDataSelectedColumns,
    setVpDataSelectedColumns,
    vehiclePerformanceFilterSidebar,
    setVehiclePerformanceFilterSidebar,
    generateSidebarFilterString,
    vehicleProfileFilterSidebar,
    setVehicleProfileFilterSidebar,
    partialSearchFilterString,
    setPartialSearchFilterString,
    vpDataAccordionExpand,
    setVpDataAccordionExpand,
    vpProfileAccordionExpand,
    setVpProfileAccordionExpand,
  };

  return (
    <VehiclePerformanceContext.Provider value={value}>
      {children}
    </VehiclePerformanceContext.Provider>
  );
};

export default VehiclePerformanceContext;
